
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AfiliadoService from "@/services/AfiliadoService";
import User from "@/models/User";
import UmbracoApiService from "@/services/UmbracoApiService";
import TourVirtualUmbracoResponse from '@/models/TourVirtual/TourVirtualUmbracoResponse';
import $ from "jquery";
@Component({})
export default class TourVirtual extends Vue {
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public name: string = "";
  public umbracoService = new UmbracoApiService();
  public tourVirtualResponse = new TourVirtualUmbracoResponse();
  @Getter("user") user: User;
  @Getter("isLoggedIn") isLoggedIn: boolean;

  async mounted() {
    document.addEventListener('click', function<HTMLTextAreaElement> (e) {
      if(e.target.className === 'modal'){
        
      }else {
        var frame  = document.getElementById('tutoIframe') as HTMLIFrameElement;
          frame.src = frame.src;
      }
    }, false);

    var html = document.getElementsByTagName("html");
      for (var i = 0; i < html.length; i++) {
        html[i].style.overflow = "visible"
        }
    if (this.isLoggedIn) {
      const str = this.$store.state.user.primerNombre.toLowerCase();
      const arr = str.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      const str2 = arr.join(" ");
      this.name = str2;
    }
    
    await this.getTourVirtualUrl();
  }
  public async omitir() {
    if (this.user.cedula) {
      await this.afiliadoService.VideoIntroPost(this.user.cedula);
      this.$router.push("/Dashboard");
    }
  }
  public async getTourVirtualUrl(){
    await this.umbracoService.getTourVirtualUrl()
		.then(resp => { 
			this.tourVirtualResponse = resp;
		});
  }
  @Watch("isLoggedIn")
  public setName(value: boolean) {
    if (value) this.name = `${this.$store.state.user.primerNombre}`;
  }
}
$("#exampleModal").on("hidden.bs.modal", function (e) {
  var $iframes = $(e.target).find("iframe");
  $iframes.each(function (index, iframe) {
    $(iframe).attr("src", $(iframe).attr("src"));
  });
});

$("#exampleModal").on("hidden.bs.modal", function (e) {
  $("#exampleModal iframe").attr("src", $("#exampleModal iframe").attr("src"));
});
